<template>
  <v-row justify="center">
    <v-dialog v-model="PersonalDialog" persistent max-width="500">
      <template v-slot:activator="{ on, attrs }">
        <div
          color="primary"
          dark
          @click="clsoe()"
          v-bind="attrs"
          v-on="on"
        >
           <v-card
                  flat
                    class="mx-auto cardTr bg1"
                    max-width="250"
                >
                    <img src="../assets/moneytransfer.png" alt="teller logo" width="40" height="40">
                    <div class="init">
                        <h5>Personal Transfer</h5>
                        <small>Transfer money to another Teller wallet</small> 
                    </div>
                </v-card>
        </div>
      </template>
      <v-card class="padd">
         <div>
          <v-container>
              <h4 class="bankT">Personal Transfer</h4>
              <v-row>
                <v-col cols="12" sm="12">
                 <div class="labelDiv">
                      <label>Wallet</label>
                    </div>
                <v-text-field
                    class="fieldtx"
                    outlined
                    dense
                    disabled
                    value='COMMISSION Account'
                  ></v-text-field>
                  <div class="labelDiv">
                      <label>Receipient</label>
                    </div>
                <v-text-field
                    class="fieldtx"
                    outlined
                    dense
                    disabled
                    value='Main Account'
                  ></v-text-field>
                    <div class="labelDiv">
                      <label>Amount</label>
                    </div>
                <v-text-field
                    class="fieldtx"
                    outlined
                    dense
                    type='number'
                    v-model="amount"
                  ></v-text-field>
                </v-col>
              </v-row>
      </v-container>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn text large @click="clsoe()">Close</v-btn>
          <v-btn dark class="btn" large @click="Transfer()">Send</v-btn>
        <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        amount:''
      }
    },
        computed: {
       User () {
        return this.$store.getters.getUser
        },
        PersonalDialog () {
        return this.$store.getters.getPersonalDialog
        },
    },
    methods: {
       clsoe(){
          this.$store.commit('setPersonalDialog', !this.PersonalDialog)
      },
      Transfer(){
         if (this.amount == "") 
          {
              let payload = {
                      status: true,
                      message:"Fill out all the required fields"
                  }
              this.$store.dispatch('SnackbarFunc', payload)
            return;
          }
          let payload = {
                    amount:this.amount,
                    customerID:this.User.customerID,
                    pin:this.User.pin,
                    route: this.$router
                  }
          this.$store.dispatch('Transfer', payload)
            }
    },
  }
</script>
<style scoped>
.cardTr{
    display: flex;
    align-items: center;
    padding: 15px;
    padding-right: 20px;
    padding-left: 20px;
    height: 100px;
    border-radius: 20px !important;
    margin-right: 20px;
    margin-left: 20px;
    margin-bottom: 20px;
    cursor: pointer;
}
.bg1{
    background-color:rgba(187, 107, 217, 0.3);
}
.init{
    margin-left: 15px;
}
.padd{
    padding: 10px;
    border-radius: 10px;
}
.bankT{
    text-align: center;
    color: #ad1684;

}
.btn{
    background-color: #ad1684 !important;
    text-transform: none;
}

@media only screen and (max-width: 700px) {
  .cardTr{
    display: flex;
    align-items: center;
    padding: 5px;
    padding-right: 10px;
    padding-left: 10px;
    height: 100px;
    border-radius: 20px !important;
    margin-right: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
    cursor: pointer;
}
}
</style>